<div class="row gx-0">
  <div class="col-lg-6">
    <mat-card-title>
      Manage Workbench Items
    </mat-card-title>
  </div>
  <div class="col-lg-6">
    <div *ngIf="workflows.length > 0" class="margin-top-md">
      <button mat-button [matMenuTriggerFor]="tableControlMenu" class="pull-right">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #tableControlMenu="matMenu">
        <button mat-menu-item (click)="expandAll()">
          <span>
            Expand All
          </span>
        </button>
        <button mat-menu-item (click)="collapseAll()">
          <span>
            Collapse All
          </span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>

<p style="line-height:0px;">&nbsp;</p>
<mat-divider> </mat-divider>
<br>

<div>
  <form [formGroup]="coeFiltersForm">
    <mat-card appearance="outlined">
      <div class="row gx-0">
        <div class="col-lg-6">
          <mat-card-header>
            <mat-card-title>
              General Filters
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row margin-top-sm">
              <mat-form-field class="col-lg-6">
                <mat-label>From Created Date</mat-label>
                <input matInput [matDatepicker]="frmDatePicker" formControlName="fromDateString">
                <mat-datepicker-toggle matIconSuffix [for]="frmDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #frmDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>To Created Date</mat-label>
                <input matInput [matDatepicker]="toDatePicker" formControlName="toDateString">
                <mat-datepicker-toggle matIconSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #toDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="row margin-top-sm">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <button type="button" class="btn btn-warning" (click)="clearDates()">Clear date ranges</button>
              </div>
            </div>
            <div class="row margin-top-sm">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <span class="help-block">
                  * Specify the workbench item's created date range. If no date range is specified, all workbench items
                  will be displayed.
                </span>
              </div>
            </div>
            <p style="line-height:0px;">&nbsp;</p>
            <mat-divider> </mat-divider>
            <div class="row margin-top-sm">&nbsp;&nbsp;&nbsp;Workflow States</div>
            <div class="row margin-top-sm margin-left-md"
              *ngFor="let i=index; let workflow of workflows">
              <div class="col-lg-8">
                <dropdown [label]="'Select ' + workflow.WORKFLOW_NODE_TYPES.NAME + ' Status'"
                  [objects]="getWorkflowStateDefinition(workflow)" [isMultiple]="true" [path]="'DESCRIPTION'"
                  [(chosenWorkflowState)]="workflowStateNames" (output)="outputEventEmitter($event)"
                  *ngIf="getWorkflowStateDefinition(workflow)">
                </dropdown>
              </div>
              <div class="col-lg-4" >
                <button style="margin: 20px;margin-left: 0px;" type="submit" mat-raised-button [color]="msg.MSG?.length!>=1 ? 'warn' :  'primary'"
                  *ngIf="getWorkflowStateDefinition(workflow)" (click)="toggleShow(workflow);(workflow.SHOW ? getWorkflowStates_Click(workflow.ID, i) : null);">
                  <mat-icon *ngIf="loadingWorkflows">
                    <mat-spinner diameter="18"> </mat-spinner>
                  </mat-icon>
                  Search
                </button>
              </div>
            </div>
          </mat-card-content>
        </div>

        <div class="col-lg-6">
          <mat-card-header>
            <mat-card-title>
              COE Filters
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row margin-top-sm">
              <mat-form-field class="col-lg-6">
                <mat-label>COE Number</mat-label>
                <input matInput type="text" placeholder="COE Number" formControlName="coeNumber" />
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>Select COE status</mat-label>
                <mat-select #selCoeStateSelect placeholder="Select Coe Status" formControlName="chosenStateNames"
                  multiple [panelClass]="'panel-location-region'">
                  <div class="row padding-md text-center" style="width:100%">
                    <div class="col">
                      <button color="primary" mat-raised-button (click)="toggleAllSelection(selCoeStateSelect,true)">
                        Select All
                      </button>
                    </div>
                    <div class="col">
                      <button color="accent" mat-raised-button (click)="toggleAllSelection(selCoeStateSelect,false)">
                        Deselect All
                      </button>
                    </div>
                  </div>
                  <mat-option *ngFor="let cstatus of CoeStatus" [value]="cstatus.value">
                    {{cstatus.display}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-card-content>

          <mat-card-actions>
            <div class="row">
              <div class="col">
                <button type="submit" mat-raised-button [color]="msg.MSG?.length!>=1 ? 'warn' :  'primary'"
                  (click)="searchCOEWorkflow();">
                  <mat-icon *ngIf="loadingWorkflows">
                    <mat-spinner diameter="18"> </mat-spinner>
                  </mat-icon>
                  Search COE Workflows
                </button>
                &nbsp;<button type="button" mat-raised-button color="accent" (click)="resetCOEFilters()"
                  mat-button>Reset</button>
              </div>
            </div>
          </mat-card-actions>
        </div>
      </div>
    </mat-card>
  </form>
</div>
<!--Workflow Types-->
<div class="row" style="margin-top:5px;">
  <div *ngFor=" let wi = index; let workflow of workflows" class="margin-left-md">
    <h3>
      <span>
        <span *ngIf="!isLoading(workflow.ID) && workflow.states" class="badge">{{getWorkflowNodeCount(workflow)}}</span>
        <span *ngIf="!isLoading(workflow.ID) && !workflow.states" class="badge">X</span>
        <span *ngIf="isLoading(workflow.ID)" class="badge"><i class="fa fa-refresh fa-spin"></i></span>
      </span>&nbsp;
      <span class="cursor-pointer"
        (click)="toggleShow(workflow);(workflow.SHOW ? getWorkflowStates_Click(workflow.ID, wi) : null)">
        {{workflow.NAME}}
      </span>
      <mat-icon class="v-align-middle cursor-pointer" [color]="workflow.SHOW ? 'primary' : ''"
        (click)="toggleShow(workflow)">
        {{workflow.SHOW ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </h3>
    <div *ngFor="let state of workflow.states; let i = index" [hidden]="!workflow.SHOW"
      class="margin-left-md margin-bottom-sm">
      <h2>
        <span>
          <span *ngIf="!isLoading(workflow.ID) && workflow.states" class="badge">&nbsp;{{state.NODES.length}}</span>
          <span *ngIf="!isLoading(workflow.ID) && !workflow.states" class="badge">X</span>
          <span *ngIf="isLoading(workflow.ID)" class="badge"><i class="fa fa-refresh fa-spin"></i></span>
        </span>&nbsp;
        <span class="cursor-pointer" (click)="toggleShow(state);">{{state.DESCRIPTION}}</span>
        <mat-icon class="v-align-middle cursor-pointer" [color]="state.SHOW ? 'primary' : ''"
          (click)="toggleShow(state)">
          {{state.SHOW ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </h2>
      <div class="mat-elevation-z8" [hidden]="!state.SHOW">
        <app-mat-table-queue [dataSource]="state.NODES" [WorkflowID]="workflow.ID" [workflow]="workflow" [state]="state"
          [no-reload]="true" [screenName]="scrName"></app-mat-table-queue>
      </div>
    </div>
  </div>
</div>